import type { EmployeesStatsTypes } from '@@partner:graphql/query/employees/employeesStats.gql'

import React from 'react'
import { useFetchEmployeesStats } from '@@partner:graphql/query/employees/employeesStats.gql'
import { generatePath } from 'react-router-dom'

import { Grid, Row, Col } from 'rsuite'
import UsersStatisticPanel from './UsersStatisticPanel'

import {
  ROUTE_USERS_MANAGEMENT,
  ROUTE_USERS_MANAGEMENT_ADD
} from '@@partner:config/routes'

const userTypesMapping: Record<EmployeesStatsTypes, string> = {
  assemblers: 'Сборщики',
  couriers: 'Курьеры',
  operators: 'Операторы',
  supervisors: 'Супервайзеры',
  brandManagers: 'Администраторы'
}

const UsersStatistic: React.FC = () => {
  const { data, loading } = useFetchEmployeesStats()

  const users = data?.stats ?? null

  return (
    <Grid fluid className="my-4 flex justify-around flex-wrap">
      <Row>
        {Object.entries(userTypesMapping).map(([ userType, header ], index) => (
          <Col
            className="my-2 w-full lg:w-1/5 sm:w-2/6"
            key={`userTypes:${userType}:${index}`}
          >
            <UsersStatisticPanel
              header={header}
              stats={users?.[userType as EmployeesStatsTypes]}
              loading={loading}
              createLink={generatePath(ROUTE_USERS_MANAGEMENT_ADD, {
                type: userType
              })}
              manageLink={generatePath(ROUTE_USERS_MANAGEMENT, {
                type: userType
              })}
            />
          </Col>
        ))}
      </Row>
    </Grid>
  )
}

export default UsersStatistic
